<template>
  <div v-if="testInfo">
    <div v-if="testInfo.answer_pre_current_item <= totalItem">
      <div v-if="$store.state.examInfo.answer_pre_remain_time">
        <CRow v-if="JSON.parse(testInfo.answer_pre_item_order)[0] == ''">
          <CCol lg="12" class="alert alert-danger">ยังไม่เปิดใช้งานแบบทดสอบ</CCol>          
        </CRow>
        <CRow>
          <CCol lg="12" v-if="$store.state.examInfo && examAllow == true">
            <form
              id="formUpdateAnswer"
              v-on:submit.prevent="sendAnswer"
              method="POST"
            >
              <CCard v-if="itemData">
                <CCardHeader color="dark" class="text-yellow"
                  >รายวิชา: {{ testInfo.course_name }}
                </CCardHeader>
                <CCardBody v-if="itemData.item_choice_5 == 9999">
                  ข้อที่ {{ testInfo.answer_pre_current_item }}/{{ totalItem }}
                  <div class="text-right text-danger">
                    เหลือเวลา: {{ timeLimit }} วินาที
                  </div>
                  <span class="text-red">(พิมพ์คำตอบ)</span>
                  <div class="indent10">{{ itemData.item_question }}</div>
                  <img
                    class="imgW600"
                    v-if="itemData.item_img_url.search('/uploads') >= 0"
                    :src="itemData.item_img_url"
                  />
                </CCardBody>
                <CCardBody v-else>
                  ข้อที่ {{ testInfo.answer_pre_current_item }}/{{ totalItem }}
                  <div class="text-right text-danger">
                    เหลือเวลา: {{ timeLimit }} วินาที
                  </div>
                  <div class="indent10">{{ itemData.item_question }}</div>
                  <img
                    class="imgW600"
                    v-if="itemData.item_img_url.search('/uploads') >= 0"
                    :src="itemData.item_img_url"
                  />
                  <div
                    class="alert alert-warning"
                    v-if="
                      itemData.item_choice_1.length != 0 ||
                      itemData.item_pic1_url.search('/uploads') >= 0
                    "
                  >
                    <img
                      class="imgW600"
                      v-if="itemData.item_pic1_url.search('/uploads') >= 0"
                      :src="itemData.item_pic1_url"
                    />
                    <div v-if="itemData.item_choice_1 != ''">
                      {{ itemData.item_choice_1 }}
                    </div>
                  </div>

                  <div
                    class="alert alert-warning"
                    v-if="
                      itemData.item_choice_2.length != 0 ||
                      itemData.item_pic2_url.search('/uploads') >= 0
                    "
                  >
                    <img
                      class="imgW600"
                      v-if="itemData.item_pic2_url.search('/uploads') >= 0"
                      :src="itemData.item_pic2_url"
                    />
                    <div v-if="itemData.item_choice_2 != ''">
                      {{ itemData.item_choice_2 }}
                    </div>
                  </div>
                  <div
                    class="alert alert-warning"
                    v-if="
                      itemData.item_choice_3.length != 0 ||
                      itemData.item_pic3_url.search('/uploads') >= 0
                    "
                  >
                    <img
                      class="imgW600"
                      v-if="itemData.item_pic3_url.search('/uploads') >= 0"
                      :src="itemData.item_pic3_url"
                    />
                    <div v-if="itemData.item_choice_3 != ''">
                      {{ itemData.item_choice_3 }}
                    </div>
                  </div>
                  <div
                    class="alert alert-warning"
                    v-if="
                      itemData.item_choice_4.length != 0 ||
                      itemData.item_pic4_url.search('/uploads') >= 0
                    "
                  >
                    <img
                      class="imgW600"
                      v-if="itemData.item_pic4_url.search('/uploads') >= 0"
                      :src="itemData.item_pic4_url"
                    />
                    <div v-if="itemData.item_choice_4 != ''">
                      {{ itemData.item_choice_4 }}
                    </div>
                  </div>
                  <div
                    class="alert alert-warning"
                    v-if="
                      itemData.item_choice_5.length != 0 ||
                      itemData.item_pic5_url.search('/uploads') >= 0
                    "
                  >
                    <img
                      class="imgW600"
                      v-if="itemData.item_pic5_url.search('/uploads') >= 0"
                      :src="itemData.item_pic5_url"
                    />
                    <div>{{ itemData.item_choice_5 }}</div>
                  </div>
                </CCardBody>
                <CCardFooter v-if="itemData.item_choice_5 == 9999">
                  ตอบ (ไม่ต้องใส่หน่วย):
                  <input
                    type="text"
                    class="form-control"
                    required
                    v-model="answered"
                  />
                  <div class="text-right" style="margin-top: 20px">
                    <button type="submit" class="btn btn-warning">
                      ส่งคำตอบ
                    </button>
                  </div>
                </CCardFooter>
                <CCardFooter v-else>
                  ตอบ:
                  <select class="form-control" required v-model="answered">
                    <option value="">--เลือก--</option>
                    <option
                      v-for="choice in choiceList"
                      :key="choice.id"
                      :value="choice"
                    >
                      {{ choice }}
                    </option>
                  </select>
                  <div class="text-right" style="margin-top: 20px">
                    <button
                      type="submit"
                      class="btn btn-warning"
                      :disabled="isActive"
                    >
                      <span v-if="isActive == false"> ส่งคำตอบ</span>
                      <span v-else>Sending...</span>
                    </button>
                  </div>
                </CCardFooter>
              </CCard>
            </form>
          </CCol>
          <CCol lg="12" v-else class="alert alert-danger">
            อนุญาตให้ทำแบบทดสอบได้เมื่อ {{ examStart }} ถึง {{ examEnd }}
            <div class="text-center">เมื่อถึงเวลาทดสอบ กรุณากด Refresh หน้านี้เพื่อแสดงข้อสอบ</div>
          </CCol>
        </CRow>
      </div>
      <div v-else class="alert alert-danger">หมดเวลาทำแบบทดสอบ</div>
    </div>
    <div v-else class="alert alert-success">สอบเสร็จแล้ว ขอให้โชคดีครับ
      <div class="text-center">
        <a class="btn btn-yellow" v-if="keyInfo" :href="$hostUrl+'php_action/uploads/'+keyInfo.keybook_file_path">Download เฉลย</a>
        <div v-else>เฉลย จะอัพโหลดให้ภายหลังนะครับ</div>
      </div>
    </div>
  </div>
</template>

<script>
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import XLSX from "xlsx"; // import xlsx
import Table from "./base/Table.vue";
import moment from "moment";

export default {
  name: "Dashboard",
  components: {
    VueGoodTable,
    Datepicker,
    vSelect,
    XLSX,
  },
  data() {
    return {
      responseContent: null,
      darkModal: false,
      userData: this.$cookies.get("user"),
      testInfo: null,
      itemList: null,
      examAllow: false,
      examStart: null,
      examEnd: null,
      itemsOrder: null,
      currentItemId: null,
      totalItem: null,
      itemData: null,
      choiceList: ["1", "2", "3", "4", "5"],
      answered: null,
      timeLimit: null,
      isActive: false,
      myIp: null,
      keyInfo: null
    };
  },
  created() {
    setInterval(() => {
      /*
      if (this.examAllow) {
        this.timer();
      }
      */
      this.timer();
    }, 1000);
  },
  mounted() {
    //FETCH KEY BOOK
    this.axios.get(this.$hostUrl + "php_action/keyAPI.php?txtAction=getKeyBook&courseId="+this.$route.params.courseId).then((response) => {
      //console.log(response.data);
      this.keyInfo = response.data.mainData;
    });
    
    //CHECK IP
    this.axios.get("https://api.ipify.org?format=json").then((response) => {
      this.myIp = response.data.ip;
    });

    //CHECK IS REGISTERED
    this.axios
      .get(
        this.$hostUrl +
          "php_action/enrollmentAPI.php?txtAction=getIsUerEnroll&userId=" +
          this.userData.adminlogin_id +
          "&courseId=" +
          this.$route.params.courseId
      )
      .then((response) => {
        //console.log(response.data);
        if (response.data.dataRows == 0) {
          alert("ท่านไม่อนุญาติให้เข้ารับการทดสอบในรายวิชานี้");
          this.$router.push({ name: "Home" });
        } else {
          //FETCH TEST DATA
          this.axios
            .get(
              this.$hostUrl +
                "php_action/examAPI2021.php?txtAction=getExamData&userId=" +
                this.userData.adminlogin_id +
                "&subject=" +
                this.$route.params.courseId
            )
            .then((response) => {
              console.log("--test data start here--");
              console.log(response.data);
              this.testInfo = response.data.mainData;
              this.itemsOrder = JSON.parse(this.testInfo.answer_pre_item_order);
              this.totalItem = this.itemsOrder.length;
              //console.log(this.totalItem);
              this.currentItemId =
                this.itemsOrder[this.testInfo.answer_pre_current_item - 1];
              //console.log(this.currentItemId);

              //COMMIT STORE NEW DATA
              this.$store.commit("setExamInfo", response.data.mainData);
              //console.log(this.$store.state.examInfo);

              //COMPARE DATE-----------------------------------------------------------
              //console.log(this.testInfo.course_start);
              //console.log(this.testInfo.course_start.replace(" ", "T"));
              let courseStart = new Date(
                this.testInfo.course_start.replace(" ", "T")
              );
              //MINUS DAYS
              courseStart.setDate(courseStart.getDate() - 0);
              //SET HOURSE
              //courseStart.setHours(0, 0, 1);
              this.examStart =
                new Date(courseStart).toLocaleDateString() +
                " " +
                new Date(courseStart).toLocaleTimeString();
              console.log("exam start: " + courseStart);

              let courseEnd = new Date(
                this.testInfo.course_end.replace(" ", "T")
              );
              //SET HOURSE
              //courseEnd.setHours(23, 59, 0);
              //console.log(courseEnd);

              this.examEnd =
                new Date(courseEnd).toLocaleDateString() +
                " " +
                new Date(courseEnd).toLocaleTimeString();
              console.log("exam end: " + courseEnd);

              let nD = new Date();
              console.log("now: " + nD);

              if (nD >= courseStart && nD < courseEnd) {
                this.examAllow = true;
              } else {
                this.examAllow = false;
              }
              console.log("exam permission: " + this.examAllow);

              //FETCH ITEM DATA
              this.axios
                .get(
                  this.$hostUrl +
                    "php_action/itemAPI.php?txtAction=getItemData&itemId=" +
                    this.currentItemId
                )
                .then((response) => {
                  console.log(response.data.mainData);
                  this.itemData = response.data.mainData;
                  this.timeLimit = this.itemData.item_limit_time;
                });
            });
        }
      });
  },
  methods: {
    sendAnswer(event) {
      this.isActive = true;
      let answerField = "reply" + this.testInfo.answer_pre_current_item;
      let currenttime = new Date().toLocaleTimeString();
      //alert(answerField);
      const form = document.getElementById(event.target.id);
      const formData = new FormData(form);
      formData.append("txtAction", "update");
      formData.append("answerSheetId", this.testInfo.answer_pre_id);
      formData.append(
        answerField,
        JSON.stringify([
          this.itemData.item_id,
          this.answered,
          this.itemData.item_key,
          currenttime,
          this.myIp,
        ])
      );
      formData.append("itemCounter", 7);
      this.axios
        .post(this.$hostUrl + "php_action/examAPI2021.php", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          console.log(response.data);
          if (response.data.updateState == "updated") {
            alert("บันทึกสำเร็จ");
            location.reload();
          } else {
            alert(response.data.error);
          }
        });
    },
    removeAtt(value) {
      var r = confirm("แน่ใจว่าต้องการลบข้อมูล?");
      if (r == true) {
        //SEND DATA
        this.axios
          .get(
            this.$hostUrl +
              "php_action/attendanceAPI.php?txtAction=delete&attId=" +
              value
          )
          .then((response) => {
            console.log(response.data);
            if (response.data.error == false) {
              this.responseContent = response.data.error;
              location.reload();
            } else {
              this.responseContent = response.data.error;
              alert(this.responseContent);
            }
          })
          .finally(() => {});
      } else {
        return true;
      }
    },
    onExport() {
      const dataWS = XLSX.utils.json_to_sheet(this.rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "export.xlsx");
    },
    updateTime() {
      //alert("เวลากำลังนับถอยหลัง");
      //SEND DATA TO UPDATE
      this.axios
        .get(
          this.$hostUrl +
            "php_action/examAPI2021.php?txtAction=updateTime&qPretestId=" +
            this.$store.state.examInfo.answer_pre_id
        )
        .then((response) => {
          console.log(response.data);
          if (response.data.error == false) {
            this.responseContent = response.data.error;
            this.$store.commit("setExamInfo", response.data.mainData);
            //location.reload();
          } else {
            this.responseContent = response.data.error;
            alert(this.responseContent);
          }
        })
        .finally(() => {});
    },
    timer() {
      if(!this.examAllow){
        console.log("timer is stoped");
        return false;
      }
      console.log("timer is running");
      
      if (this.timeLimit) {
        this.timeLimit -= 1;
        //console.log(this.timeLimit);
        if (this.timeLimit == 0) {
          alert("หมดเวลา");
          let answerField = "reply" + this.testInfo.answer_pre_current_item;
          let currenttime = new Date().toLocaleTimeString();
          //alert(answerField);
          const formData = new FormData();
          formData.append("txtAction", "update");
          formData.append("answerSheetId", this.testInfo.answer_pre_id);
          formData.append(
            answerField,
            JSON.stringify([
              this.itemData.item_id,
              "timed out",
              this.itemData.item_key,
              currenttime,
              this.myIp,
            ])
          );
          formData.append("itemCounter", 7);
          this.axios
            .post(this.$hostUrl + "php_action/examAPI2021.php", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              console.log(response.data);
              if (response.data.updateState == "updated") {
                alert("บันทึกสำเร็จ");
                location.reload();
              } else {
                alert(response.data.error);
              }
            });
        }
      }
    },
  },
};
</script>
